
import { Link, useLocation } from "react-router-dom";

const tabs = [
    { name: "COD Remittance", path: "/CodRemittances" },
    { name: "Wallet Transactions", path: "/wallettransactions" },
    { name: "Shipping Charges", path: "/shippingcharges" },
    { name: "New Weight Reconciliation", path: "/newweightreconciliation" },
    { name: "Early COD Remittance Plan", path: "/earlycodremittanceplan" },
];

const BillingHeader = () => {
    const location = useLocation();


    return (
        <div className="px-6 pt-6 pb-2 bg-white rounded-lg">
            <h2 className="text-xl font-bold">Billing - COD Remittance</h2>

            <div className="mt-4 flex flex-wrap gap-2 border-b">
                {tabs?.map((tab) => (
                    <Link
                        key={tab?.name}
                        to={tab?.path}
                        className={`px-4 py-2 text-sm relative transition-all duration-200 ${location?.pathname === tab?.path
                            ? "font-semibold text-black after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:bg-black"
                            : "text-gray-600 hover:text-black"
                            }`}
                    >
                        {tab?.name}
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default BillingHeader;



// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import SideBar from '../SideBar.js';

// const tabs = [
//     { name: "COD Remittance", path: "/CodRemittances" },
//     { name: "Wallet Transactions", path: "/wallettransactions" },
//     { name: "Shipping Charges", path: "/shippingcharges" },
//     { name: "New Weight Reconciliation", path: "/newweightreconciliation" },
//     { name: "Early COD Remittance Plan", path: "/earlycodremittanceplan" },
// ];

// const BillingHeader = () => {
//     const [activeTab, setActiveTab] = useState("");  // No active tab initially
//     const [clickedTab, setClickedTab] = useState(""); // Track the first click

//     const handleTabClick = (tabName) => {
//         if (clickedTab === tabName) {
//             // If the tab is clicked again, make it fully active
//             setActiveTab(tabName);
//         } else {
//             // First click: show content but don't activate
//             setClickedTab(tabName);
//         }
//     };

//     const renderContent = () => {
//         switch (clickedTab) {  // Show content based on clicked tab
//             case "COD Remittance":
//                 return (
//                     <div className="mt-6 grid grid-cols-1 md:grid-cols-4 gap-4 text-center">
//                         <div className="p-4 bg-slate-100 rounded-lg">
//                             <p className="text-sm text-gray-500">Remitted Till Date</p>
//                             <p className="text-xl font-semibold">₹146947</p>
//                         </div>
//                         <div className="p-4 bg-slate-100 rounded-lg">
//                             <p className="text-sm text-gray-500">Last Remittance</p>
//                             <p className="text-xl font-semibold">₹6449</p>
//                         </div>
//                         <div className="p-4 bg-slate-100 rounded-lg">
//                             <p className="text-sm text-gray-500">Next Remittance (Expected)</p>
//                             <p className="text-xl font-semibold">₹6375</p>
//                         </div>
//                         <div className="p-4 bg-slate-100 rounded-lg">
//                             <p className="text-sm text-gray-500">Total Remittance Due</p>
//                             <p className="text-xl font-semibold">₹29439</p>
//                         </div>
//                     </div>
//                 );
//             case "Wallet Transactions":
//                 return <div className="p-4">Wallet Transactions Page Content</div>;
//             case "Shipping Charges":
//                 return <div className="p-4">Shipping Charges Page Content</div>;
//             case "New Weight Reconciliation":
//                 return <div className="p-4">New Weight Reconciliation Page Content</div>;
//             case "Early COD Remittance Plan":
//                 return <div className="p-4">Early COD Remittance Plan Page Content</div>;
//             default:
//                 return null;
//         }
//     };

//     return (
//         <div className="flex bg-slate-100">
//             <SideBar />
//             <div className="flex-1 p-6 overflow-x-hidden ml-16">
//                 <div className="p-6 bg-white rounded-lg">
//                     <h2 className="text-xl font-bold">Billing - COD Remittance</h2>
//                     <p className="text-red-600 text-sm font-semibold mt-3">
//                         Attention: Weight Discrepancy Data Will Be Available On The New Tab (New Weight Reconciliation) Starting January 13th 2025.
//                         <Link to="/newweightreconciliation" className="text-blue-500 underline">Click Here</Link>
//                     </p>

//                     <div className="mt-4 flex flex-wrap gap-2 border-b">
//                         {tabs.map((tab) => (
//                             <button
//                                 key={tab.name}
//                                 className={`px-4 py-2 text-sm relative focus:outline-none ${activeTab === tab.name ? "border-b-2 border-slate-900 font-semibold" : ""
//                                     }`}
//                                 onClick={() => handleTabClick(tab.name)}
//                             >
//                                 {tab.name}
//                             </button>
//                         ))}
//                     </div>

//                     <div className="mt-6">{renderContent()}</div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default BillingHeader;
